import { useState, useEffect, useRef } from 'react';
import {
	indexRows,
	init,
	setRows,
	sortByHeader,
	toggleRow,
} from '../../../../store/adminSearch/actions';
import PersonSearch from '../../../../components/UI/Input/PersonSearch/PersonSearch';
import { fetchPersonSearch } from './WorkQueueAdmin_api';
import { nanoid } from 'nanoid';
import { useDispatch, useSelector } from 'react-redux';
import { ACTION_TYPES } from '../../../../components/UI/MDC/DataTable/_types';
import { ADMIN_HEADERS } from './_constants';
const AdminSearch = ({ toggleAddAdmin, currentAdmins }) => {
	const dispatch = useDispatch();
	const [errorMessage, setErrorMessage] = useState('');
	const [loading, setLoading] = useState(false);

	const rActions = useSelector(state => state.adminSearchTable.actions);
	const rHeaders = useSelector(state => state.adminSearchTable.headers);
	const rRows = useSelector(state => state.adminSearchTable.rows);

	const ifAdminAlreadyExists = async row => {
		const adminExists = adminRef.current.some(admin => {
			return admin.Cells.FI_ID.Value === row.Cells.FI_ID.Value;
		});
		return adminExists;
	};

	const adminRef = useRef();
	adminRef.current = currentAdmins;

	useEffect(() => {
		adminRef.current = currentAdmins;
	}, [currentAdmins]);

	const toggleOnChange = async row => {
		var exists = await ifAdminAlreadyExists(row);
		if (exists) {
			alert('User is already an admin.');
		} else {
			dispatch(toggleRow(row));
			toggleAddAdmin(row);
			dispatch(setRows([]));
		}
	};

	// Initial redux store initialization for person search component
	useEffect(() => {
		dispatch(
			init({
				actions: [
					{
						Type: ACTION_TYPES.TOGGLE,
						onChangedHandler: (_, __, row) => {
							toggleOnChange(row);
						},
					},
				],
				headers: ADMIN_HEADERS.map((header, index) => {
					return {
						Value: header,
						props: {
							onSortChange: sortOrder =>
								dispatch(sortByHeader(header, sortOrder)),
							sort: index === 0 ? 1 : null,
						},
					};
				}),
			})
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<>
			<PersonSearch
				errorMessage={errorMessage}
				label='Person Search'
				dataTable={{
					label: 'Search Results',
					actions: rActions,
					headers: rHeaders,
					rows: rRows.filter(row => row.isDisplayed === true),
					onTextFieldChangedHandler: e =>
						dispatch(indexRows(e.target.value)),
				}}
				isLoading={loading}
				onButtonClickedHandler={payload => {
					setLoading(true);
					fetchPersonSearch(payload).then(response => {
						switch (response.status) {
							case 200:
								switch (response.data.responseCode) {
									case 200:
										let payload = response.data.payload;

										payload.forEach(row => {
											row.ActionCells = [
												{
													BindTo: 0,
													Checked: false,
													Key: nanoid(),
													Text: 'Add as Admin',
												},
											];
											row.isDisplayed = true;
											return row;
										});
										dispatch(setRows(payload));
										setErrorMessage(null);
										setLoading(false);
										break;
									default:
										setErrorMessage(
											response.data.messages[0].Value
										);
										setLoading(false);
										break;
								}
								break;
							default:
								break;
						}
					});
				}}
				requestTarget='REQUESTEE'
			/>
		</>
	);
};

export default AdminSearch;
